module.exports = __webpack_public_path__ + "goTop.5d210004.png";